const paths = {
  auth: '/auth',
  signUp: '/auth/signup',
  signIn: '/auth/login',
  otp: '/auth/otp',
  forgotPassword: '/auth/forgot-password',
  updatePassword: '/auth/update-password/:verificationCode',
  verify: '/auth/verify',

  main: '/',

  splitPayments: '/split-payments',
  splitPaymentsTransactions: '/split-payments/transactions',
  splitPaymentsPayees: '/split-payments/payees',
  splitPaymentsPayeeDetails: '/split-payments/payee/:id',
  splitPaymentsRules: '/split-payments/rules',
  splitPaymentsRuleDetails: '/split-payments/rule/:id',
  splitPaymentsPayouts: '/split-payments/payouts',

  onlinePayments: '/online-payments',
  onlinePaymentsTransactions: '/online-payments/transactions',
  onlinePaymentsRecurringPayments: '/online-payments/recurring-payments',
  onlinePaymentsPaymentLinks: '/online-payments/payment-links',
  onlinePaymentsRefunds: '/online-payments/refunds',
  onlinePaymentsDisputes: '/online-payments/disputes',
  onlinePaymentsSettings: '/online-payments/settings',

  paymentAcceptance: '/payment-acceptance',
  businessIntelligence: '/business-intelligence',
  reports: '/reports',
  accounts: '/accounts',
  integrationGuides: '/integration-guides',

  paymentAnalytics: '/payment-analytics',
  chat: '/chat',
  profile: '/profile',
  logout: '/logout',
  checkout: '/checkout/:paymentId',
  onboarding: '/onboarding',
  sandbox: '/sandbox',

  notFound: '*',
};

export default paths;
